import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { BaseComponent } from "../../shared/base/base.component";
import { ActivatedRoute } from "@angular/router";
import { LoggedUserService } from "../../services/common/logged-user.service";

@Component({
  selector: "help-component",
  templateUrl: "./help.component.html",
  styleUrls: ["./help.component.css"],
})
export class HelpComponent extends BaseComponent implements OnInit {
  links: any[] = [];

  constructor(
    private http: HttpClient,
    loggedUserService: LoggedUserService,
    route: ActivatedRoute
  ) {
    super(loggedUserService, route);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
